export const contractTypeLabel = 'Contract type';
export const centriCareContract = 'centricare';
export const sourceReplacementCodeInLText = 'SORC';
